import useContract from './useContract';
import WrappedEvilNoundles from '../contracts/WrappedEvilNoundles.json';

const useWrappedEvilNoundles = () =>
  useContract(
    process.env.NEXT_PUBLIC_WRAPPED_EVIL_NOUNDLES_CONTRACT_ADDRESS,
    WrappedEvilNoundles.abi
  );

export default useWrappedEvilNoundles;
